__turbopack_context__.v({
  "jerkup": "pplx-input-module__lfdOFG__jerkup",
  "retroButton": "pplx-input-module__lfdOFG__retroButton",
  "retroInput": "pplx-input-module__lfdOFG__retroInput",
  "retroInputContainer": "pplx-input-module__lfdOFG__retroInputContainer",
  "retroInputWrapper": "pplx-input-module__lfdOFG__retroInputWrapper",
});
